export default {
    progress: {
        getBatches: false,
        getAllBatches: false,
        createBatch: false,
        getSampleBatchList: false,
        addSampleToBatch: false,
        updateSampleInBatch: false,
        removeSampleFromBatch: false,
        startBatchProcessing: false,
        labelsPrinting: false,
        exportBatchToCsv: false,
        exportBatchSamplesToXlsx: false,
        getMissingSamples: false,
        moveSampleToArchive: false,
        moveSampleToSuitableBatch: false,
        getCasesWithMissingSamples: false,
        shiftSamplesToLeft: false,
        shiftSamplesToRight: false
    },
    batches: [],
    allBatches: [],
    sampleBatchesByBatchId: {},
    missingSamples: [],
    casesWithMissingSamples: [],
    totalBatches: 0,
    pagination: {
        rowsPerPage: 5,
        page: 1
    },
    filters: {
        createdFrom: null,//moment().subtract(1, 'month').format('YYYY-MM-DD'),
        createdTo: null,//moment().format('YYYY-MM-DD'),
        statuses: []
    },
    availableBatchStatuses: [
        {
            title: 'Preparing',
            value: 'preparing'
        },
        {
            title: 'In Work',
            value: 'in_work'
        },
        {
            title: 'Done',
            value: 'done'
        }
    ],
    availableBatchStatusesByValue: {}
}